import '../setup/ifmsSetup/ifmsSetup.css';
import { useContext, useEffect, useRef } from 'react';

import useJobMenu from '../../hooks/useJobMenu';

import useGlobalYesNoDialog from '../../hooks/useGlobalYesNoDialog';
import useFunctionKeys from '../../hooks/useFunctionKeys';
import { useTypedFastStorage } from '../../hooks/useFastStorage';
import useFunction from '../../hooks/useFunction';
import fastStorage from '../../fastStorage';

import CodesFactory from './implementation/CodesFactory';
import constants from '../../constants';
import { IfmsConfigMenuItem, IfmsConfigOperationMenu } from '../../config/types';
import IfmsSideMenu from '../../IfmsSideMenu';
import { FmsSecTask } from '../../fms.core/constants';
import { MenuFilterGrents } from '../../util';
import ApplicationContext from '../../ApplicationContext';
import _ from 'lodash';
import { XCellType } from '../../framework.core/XExportColumn';
import * as XCol from '../../framework.core/XExportColumn';
import useSuntekSettings from '../../hooks/useSuntekSettings';
import IfmsReferenceFilesContext from './IfmsReferenceFilesContext';
import { FilterStorageVersion, isFilterObjectEmpty } from '../../filtering';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import TooltipButton from '../../ui/TooltipButton';
import { useHistory } from 'react-router';
import { removeFromStorage } from '../../features/storageSlice';
import { useStore } from 'react-redux';

interface ICheckLastSelectedMenu {
  allMenuIndexArray: any[],
  lastSelectedIndexArray: any[]
}


const checkLastSelectedMenu: ICheckLastSelectedMenu = { allMenuIndexArray: [], lastSelectedIndexArray: [] }

const menus: IfmsConfigOperationMenu = {
  operation: 'Reference Files',
  job: [
    {
      text: 'Ocean Shipment', level: 0, metadata: { index: 0, inlineEdit: true }, nonItemThenHide: true,
      items: [
        { text: 'Original B/L Type', level: 1, metadata: { index: 0, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeBLType },
        { text: 'Container Size', level: 1, metadata: { index: 1, inlineEdit: false }, fmsSecTask: FmsSecTask.CodeContainerType },
        { text: 'Move Type', level: 1, metadata: { index: 2, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeMoveType },
        { text: 'Schedule D&K', level: 1, metadata: { index: 3, inlineEdit: false }, fmsSecTask: FmsSecTask.CodeOceanPort },
        { text: 'Vessel Name', level: 1, metadata: { index: 4, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeVessel },
        { text: 'Carrier Code', level: 1, metadata: { index: 11, inlineEdit: false }, fmsSecTask: FmsSecTask.CodeScac },
        { text: 'Buying Rate', level: 1, metadata: { index: 12, inlineEdit: false, NoCanada: true },  fmsSecTask: FmsSecTask.CodeScac }
      ],
    },
    {
      text: 'Air Shipment', level: 0, metadata: { index: 5, inlineEdit: false }, nonItemThenHide: true,
      items: [
        { text: 'Airline Code', level: 1, metadata: { index: 5, inlineEdit: false }, fmsSecTask: FmsSecTask.CodeAirLine },
        { text: 'Airport Code', level: 1, metadata: { index: 6, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeAirPort },
      ],
    },
    {
      text: 'Other Shipment Type', level: 0, metadata: { index: 7, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeOtherOPType
    },
    {
      text: 'AES', level: 0, metadata: { index: 8, inlineEdit: true }, nonItemThenHide: true,
      items: [
        { text: 'Export Info Code', level: 1, metadata: { index: 8, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeExportInfo },
        { text: 'Export License Code', level: 1, metadata: { index: 9, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeExportLic },
        { text: 'Schedule B Code', level: 1, metadata: { index: 10, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeScheduleB },
      ],
    },
    {
      text: 'Arrival Notice Title', level: 0, metadata: { index: 13, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeANTitle
    },
    // {
    //   text: 'Commodity List', level: 0, metadata: { index: 14, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeCommodity
    // },
    {
      text: 'Currency Code', level: 0, metadata: { index: 15, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeCurrency
    },
    {
      text: 'Exchange Rate', level: 0, metadata: { index: 16, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeExchangeRate
    },
    {
        text: 'Task/Memo Title', level: 0, metadata: { index: 17, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeMemoTitle
    },
    {
      text: 'Region Code', level: 0, metadata: { index: 19, inlineEdit: true }, nonItemThenHide: true,
      items: [
        { text: 'Country Code', level: 1, metadata: { index: 19, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeCountry },
        { text: 'State Code', level: 1, metadata: { index: 20, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeState },
        { text: 'UN Location Code', level: 1, metadata: { index: 21, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeUNLocation },
      ],
    },
    {
      text: 'EDI 315 Code', level: 0, metadata: { index: 22, inlineEdit: true }, fmsSecTask: FmsSecTask.CodeEDI315Code
    },
  ],
  report: []
};

export function getReferenceFilesMenus(): IfmsConfigOperationMenu {
  return _.cloneDeep(menus);
}

export function sortingListData(listItemObj: any, listData: any[], setData: any, orderBy: any, returnData: boolean = false, useCustomIndex: boolean = false) {
  if (listData.length === 0) {
    setData([]);
    return;
  }

  let customIndex = 0; //useCustomIndex�� true�϶� ���

  const findListItem: XCol.XExportColumn = listItemObj.getExportCollection().find((x: XCol.XExportColumn) => x.dataIndex === orderBy.orderBy);
  if (findListItem) {
    const typeOfOrderByValue = findListItem.type;
    const dataArray: (typeof listItemObj)[] = Array.from(listData);

    dataArray.sort((a, b) => {
      let valueA = a[orderBy.orderBy];
      let valueB = b[orderBy.orderBy];
      let compareResult = 0;

      switch (typeOfOrderByValue) {
        case XCellType.String:
          if (valueA === null) valueA = ''
          if (valueB === null) valueB = ''
          compareResult = valueA.localeCompare(valueB);
          break;

        case XCellType.Double:
          compareResult = valueA - valueB;
          break;

        case XCellType.Date:
        case XCellType.DateTime:
          const dateA = new Date(valueA).getTime();
          const dateB = new Date(valueB).getTime();
          compareResult = dateA - dateB;
          break;

        case XCellType.Bool:
        case XCellType.StrBool:
          compareResult = valueA === valueB ? 0 : valueA ? -1 : 1;
          break;

        default:
          break;
      }

      return orderBy.orderByAscending ? compareResult : -compareResult;
    });

      if (useCustomIndex) {
          if (listItemObj.name === "TaskBoardListItem") {
              dataArray.map(x => {
                  if (x.sortOrder === 0) {
                      customIndex += 1;
                      x.customIndex = customIndex;
                  }
              })
          }
      }

      if (returnData) return dataArray;
      else setData(dataArray);
  }
}

//oriData must have isUpdate Prop.
export function checkTabIsDirty(listItemObj: any, oriData: any[], curData: any[]) {
  //if (oriData.length === 0 && curData.length === 0) return false;
  if (oriData.length !== curData.length) return true;

  const dataIndexArray: string[] = listItemObj.getExportCollection().map((x: XCol.XExportColumn) => x.dataIndex);
  const updateIndexes: number[] = findUpdateIndexes(curData, element => element.isUpdate);
  let isDirty = false;
  updateIndexes.forEach(updateIndex => {
    for (let j = 0; j < dataIndexArray.length; j++) {
      if (oriData[updateIndex][dataIndexArray[j]] !== curData[updateIndex][dataIndexArray[j]]) {
        isDirty = true;
        break;
      }
    }
  })
  return isDirty;
};

function findUpdateIndexes(arr: number[], condition: (element: any) => boolean): number[] {
  const indexes: number[] = [];
  arr.forEach((element: number, index: number) => {
    if (condition(element)) {
      indexes.push(index);
    }
  });
  return indexes;
}

export interface CarrierInfo {
  tbId: number,
  code: string,
};


function ReferenceFiles() {
  useFunctionKeys({ onEsc: cancel });

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  const getExternalFunctions = useFunction({
    callbacks: ['ifmsReferenceFilesSave', 'ifmsReferenceFilesCancel']
  });

  const storage = useAppSelector(x => x.storage);
  const store = useStore();

  const dispatch = useAppDispatch();
  const history = useHistory();
  const { goBack } = useJobMenu('Reference Files', constants.operations.standalone, null, true, cleanup);

  const appContext = useContext(ApplicationContext);
  const suntekSettings = useSuntekSettings();

  const [selectedMenuIndex, _setSelectedMenuIndex,,selectedMenuIndexRef] = useTypedFastStorage<number>('referenceFilesSelected', 0);
  const lastSelectedMenuIndexRef = useRef(0);
  const selectedSideMenuIndex = useRef(0);
  const [carrierBuyRate, setCarrierBuyRate,] = useTypedFastStorage<CarrierInfo | null>('carrierBuyRate', null);
  const [hideTab, setHideTab,] = useTypedFastStorage<boolean>('hideTab', true);

  const selectedSideMenuClassName = !appContext.useDarkMode ? 'ifms-side-menu-item-selected-onclick' : 'ifms-side-menu-item-selected-onclick-darkmode';
  const url = `${history.location.pathname}${history.location.search}`;

  const userMenus = _.cloneDeep(menus);

  useEffect(() => {
    initilizeCheckMenuArray();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const findReferenceFilesSideMenu = document.getElementById(`Reference Files-ifms-side-menu-${selectedSideMenuIndex.current}`);
    if (findReferenceFilesSideMenu)
      findReferenceFilesSideMenu.className = selectedSideMenuClassName;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSideMenuIndex, hideTab, appContext.useDarkMode])

  if (suntekSettings.company?.country === 'CANADA' || hideTab) {
    userMenus.job = userMenus.job.map(job => {
      const filteredItems = job.items?.filter(f => !f.metadata.NoCanada);
      const newJob = {
        ...job,
        items: filteredItems
      }
      return newJob;
    })
  }
  if (!hideTab) {
    userMenus.job = userMenus.job.map(job => {
      const addItem = { text: 'Buying Rate', level: 1, metadata: { index: 12, inlineEdit: false, NoCanada: true }, }
      if (job.text === 'Ocean Shipment') {
        const findIndex = job.items?.findIndex(f => f.metadata.index === 12) ?? -1;
        if (findIndex < 0) {
          job.items?.push(addItem);
        }
      }
      const newJob = {
        ...job,
        items: job.items
      }
      return newJob;
    })
    initilizeCheckMenuArray();
  }

  function initilizeCheckMenuArray() {
    checkLastSelectedMenu.allMenuIndexArray.splice(0);
    checkLastSelectedMenu.lastSelectedIndexArray.splice(0);

    for (let index = 0; index < userMenus.job.length; index++) {
      if (userMenus.job[index].items)
        userMenus.job[index].items?.map(x => checkLastSelectedMenu.allMenuIndexArray.push({ menuIndex: x.metadata.index, sideMenuIndex: index }));
      else
        checkLastSelectedMenu.allMenuIndexArray.push({ menuIndex: userMenus.job[index].metadata.index, sideMenuIndex: index });

      checkLastSelectedMenu.lastSelectedIndexArray.push({ lastSelectedItemIndex: userMenus.job[index].metadata.index, sideMenuIndex: index })
    }

    if (userMenus.job[0].metadata.index != 0) {
      if (selectedMenuIndex == 0)
        setSelectedMenuIndex(userMenus.job[0].metadata.index);
      else
        setSelectedMenuIndex(selectedMenuIndex!);
    }
  }

  function setSelectedMenuIndex(i: number) {
    selectedMenuIndexRef.current = i;
    _setSelectedMenuIndex(i);
    resetSelectedButton(i);
  }

  const currentScreenHasInlineEditing = useRef<boolean>(true); // Original B/L Type
  const currentScreenTitle = useRef<string>('Original B/L Type'); // Original B/L Type

  async function cancel() {
    const modals = document.querySelectorAll('[class^="ReactModal__Content"]');
    if (modals.length > 0) {
      return false;
    }
    if (fastStorage['ifms-referenceFiles-haschanges']) {
      const doSave = await showGlobalYesNoDialog(
        <div>
          There are unsaved changes. Do you want to save?
        </div>
        , false, 1, true);

      const externalFunctions = getExternalFunctions();

      if (doSave) {
        await externalFunctions.ifmsReferenceFilesSave();
      } else {
        await externalFunctions.ifmsReferenceFilesCancel();
      }
      fastStorage['ifms-referenceFiles-haschanges'] = false;
    }

    goBack();
    return true;
  }

  function cleanup() {
    Object.keys(fastStorage).filter(k => k.includes(url)).forEach(k => delete fastStorage[k]);

    const storeStorage = store.getState().storage;
    const keysToDelete = Object.keys(storeStorage).filter(key => 
      key.includes(url)
    );
    keysToDelete.forEach(key => {
      dispatch(removeFromStorage(key));
    });
  }

  async function onMenuItemClicked(item: IfmsConfigMenuItem) {
    const menuItemIndex: number = item.metadata.index;
    if (menuItemIndex !== selectedMenuIndexRef.current) {
      if (fastStorage['ifms-referenceFiles-haschanges']) {
        // if (currentScreenHasInlineEditing.current) {
        //   await doShowGlobalOkDialog(<p>Please save '{currentScreenTitle.current}' before going to next reference files</p>);

        //   let tabChanged = false;
        //   if (menus.job[selectedSideMenuIndex.current].items) {
        //     const index = menus.job[selectedSideMenuIndex.current].items?.findIndex(x => x.metadata.index === menuItemIndex); 
        //     tabChanged = index === -1; 
        //   } else {
        //     tabChanged = menus.job[selectedSideMenuIndex.current].metadata.index !== menuItemIndex;
        //   }
        //   if (tabChanged) {
        //     const alreadySettingsMenuOpend = document.querySelectorAll(`.${selectedSideMenuClassName}`);
        //     for (let i = 0; i < alreadySettingsMenuOpend.length; ++i) {
        //       alreadySettingsMenuOpend[i].className = 'ifms-side-menu-item';
        //     }
        //     const submenuDom = document.getElementById(`Reference Files-ifms-side-menu-${selectedSideMenuIndex.current}`) as HTMLElement;
        //     if (submenuDom)
        //       submenuDom.className = selectedSideMenuClassName;
        //   }
        //   return;
        // }

        const doSave = await showGlobalYesNoDialog(
          <div>
            There are unsaved changes. Do you want to save?
          </div>
        ,false, 1, true);

        const externalFunctions = getExternalFunctions();

        if (doSave) {
          await externalFunctions.ifmsReferenceFilesSave();
        } else {
          await externalFunctions.ifmsReferenceFilesCancel();
        }
      }
      setSelectedMenuIndex(getLastSelectedItemIndex(menuItemIndex));
      if (item.items)
        currentScreenHasInlineEditing.current = item.items.find(x => x.metadata.index === selectedMenuIndexRef.current)?.metadata.inlineEdit;
      else
        currentScreenHasInlineEditing.current = !!item.metadata?.inlineEdit;

      currentScreenTitle.current = item.text as string;
      selectedMenuIndexRef.current = getLastSelectedItemIndex(menuItemIndex);
      fastStorage['ifms-referenceFiles-haschanges'] = false;
    }
  }


  //security 필터링 후 남은 첫 번째 item의 index로 상위 menu의 index를 update
  function updateMenuIndexFromFirstChild(job: IfmsConfigMenuItem[]) {
    return job.map((item) => {
      if (!item.items?.length) return item;

      return {
        ...item,
        metadata: {
          ...item.metadata,
          index: item.items[0].metadata?.index,
        },
      };
    });
  }

  //let grents = appContext.securityGrants;
  //if(menus &&  menus.job) menus.job = MenuFilterGrents(menus.job, grents);
  if (userMenus && userMenus.job) {
    //userMenus.job = MenuFilterGrents(userMenus.job, grents, appContext);
    userMenus.job = updateMenuIndexFromFirstChild(
      MenuFilterGrents(userMenus.job, appContext.securityGrants, appContext)
    );
  } 

  let buttonNameArray: {
    name: any,
    index: number,
    item: IfmsConfigMenuItem
  }[] = [];

  for (let i = 0; i < userMenus.job.length; i++) {
    const items = userMenus.job[i].items;
    if (items && items?.length > 0) {
      for (let j = 0; j < items.length; j++) {
        const item = items[j];
        if (item.metadata.index === selectedMenuIndex) {
          items.forEach(x => {

            buttonNameArray.push({ name: x.text, index: x.metadata.index, item: x });

          });
        }
        else
          if (buttonNameArray.length > 0) {
            selectedSideMenuIndex.current = i;
            break;
          }

      }
    }
    else {
      if (userMenus.job[i].metadata.index === selectedMenuIndex)
        buttonNameArray.push({ name: userMenus.job[i].text, index: userMenus.job[i].metadata.index, item: userMenus.job[i] });
    }
    if (buttonNameArray.length > 0) {
      selectedSideMenuIndex.current = i;
      break;
    }
  }

  function resetSelectedButton(index: number) {
    const lastIndex = selectedMenuIndexRef.current ?? 0;
    if (lastIndex !== index) return;
    const otherElement = document.getElementsByClassName('e-settings-btn-selected');
    for (let i = 0; i < otherElement.length; i++) {
      otherElement[i].className = 'e-settings-btn';
    }
    const clickElement = document.getElementById(`settings-btn-${index}`) as HTMLElement;
    if(clickElement) clickElement.classList.add('e-settings-btn-selected');
  }

  function settingsMenuClick(index: number, item: IfmsConfigMenuItem) {
    lastSelectedMenuIndexRef.current = index;

    const menuIndexData = checkLastSelectedMenu.allMenuIndexArray.find(x => x.menuIndex === index);
    if (menuIndexData) {
      const lastSelectedIndexData = checkLastSelectedMenu.lastSelectedIndexArray.find(x => x.sideMenuIndex === menuIndexData.sideMenuIndex);
      if (lastSelectedIndexData) _.set(lastSelectedIndexData, 'lastSelectedItemIndex', index);
    }

    resetSelectedButton(index);
    onMenuItemClicked(item);
  }

  function getLastSelectedItemIndex(index: number): number {
    const sideMenuIndex = checkLastSelectedMenu.allMenuIndexArray.find(x => x.menuIndex === index).sideMenuIndex;
    const lastSelectedItemIndex = checkLastSelectedMenu.lastSelectedIndexArray.find(x => x.sideMenuIndex === sideMenuIndex).lastSelectedItemIndex;
    const isNotChangeTabMenu = lastSelectedItemIndex === index;
    return isNotChangeTabMenu ? index : lastSelectedItemIndex;
  }

  function getTabLabel(index: number, label: string) {
    let filter = <></>;

    const otherStorageKey = `filter-${FilterStorageVersion}-${url}-${index}`;
    const screenFilter = storage[otherStorageKey];
  
    if (!isFilterObjectEmpty(screenFilter)) {
      filter =
        (
          <div style={{ marginLeft: 'auto', marginTop: '-7px' }}>
            <TooltipButton
              jobMenuLabel="Reference Files"
              jobMenuUrl={url}
              standAloneInfo={{ index: index }}
              isActiveMenu={selectedMenuIndex === index}
            />
          </div>
        );
    }
  
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        marginTop: '-3px', 
        fontSize: '10px', 
        justifyContent: 'center' 
      }}>
        <div style={{ 
          fontFamily: 'Inter', 
          flex: 1, 
          textAlign: 'center' 
        }}>
          <span>{label}</span>
        </div>
        {filter}
      </div>
    );
  }
  

  return (
    <div className="doc-details-v2-no-side-menu">
      <div className={`settings-container background-${appContext.backgroundColor}`}>
        <div style={{ display: 'flex' }}>
          <div id="reference-files-menu-parent" style={{ width: '210px', height: 'calc(100vh - 160px)' }}>
            <IfmsSideMenu
              parentId="reference-files-menu-parent"
              menuId="reference-files-menu"
              menus={userMenus}
              onMenuItemClicked={onMenuItemClicked}
              operation={"Reference Files"}
              customZIndex={997}
            />
          </div>
          <div>
            <div className="oi-doc-title-row">
              <span className="settings-title"></span>
              <div id="settings-placeholder">
                {/* child windows can inject content here */}
                <div id="ifms-settings-menu-link-buttons-container" style={{ width: '1005px', marginBottom: '-20px' }}>
                  <div id="ifms-settings-menu-link-buttons">
                    {buttonNameArray.map((j) =>
                      <div key={`ifms-settings-btn-container-${j.index}`} className="ifms-settings-btn-container" >
                        <button className={j.index === selectedMenuIndex ? 'e-settings-btn-selected' : 'e-settings-btn'} id={`settings-btn-${j.index}`} onClick={() => { settingsMenuClick(j.index, j.item) }}>
                          {getTabLabel(j.index, j.name)}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* <div style={{ marginLeft: 'auto' }}></div> */}
              <div id="settings-command-placeholder" className="ifms-common-bar-element-center"></div>
              {/* <div className="ifms-common-bar-element ifms-left-separator-light-gray">
                <CloseButton name='reference-files-close-button' mode='light' onClick={cancel} />
              </div> */}
            </div>
            <div className="settings-content" style={{ marginLeft: '10px' }}>
              <IfmsReferenceFilesContext.Provider value={{ cancel }}>
                <CodesFactory componentIndex={selectedMenuIndex} carrierBuyRate={carrierBuyRate} setCarrierBuyRate={setCarrierBuyRate} setHideTab={setHideTab} />
              </IfmsReferenceFilesContext.Provider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReferenceFiles;
